const INITIALSTATE = {
    tutorSettingData: {},
    tutorSettingSubject:{}
  };
  
  const TutorSettingReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
      case "TUTOR_SETTING_STORE_DATA": {
        return { ...state, tutorSettingData: action.payload };
      }
      case "TUTOR_SETTING_SUBJECT_DATA": {
        return { ...state, tutorSettingSubject: action.payload };
      }
       
     
      default: {
        return state;
      }
    }
  };
  
  export default TutorSettingReducer;
  